import fullUrl from '../fullUrl';

export default function getEmbedPlayerUrl(guideId) {
  return fullUrl(`/embed/player/${guideId}/`);
}
